import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, Renderer2 } from '@angular/core';
import { ListComponentGeneric } from '../../../../ui/generics';
import { NotificationService } from '../../../../core/services';
import { IMainStoreInactiveVariant } from '../../core/interfaces/IMainStoreInactiveVariant';
import { ArticlesService } from '../../../articles/core/ArticlesService';
import { FilterOperator } from '../../../../core/types';
import {
  ArticlesServiceErrorResolverService
} from '../../../articles/core/error-resolvers/articles-service-error-resolver.service';

@Component({
    selector: 'app-main-store-inactive-variants-with-stock-list',
    templateUrl: './main-store-inactive-variants-with-stock-list.component.html',
    styleUrl: './main-store-inactive-variants-with-stock-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MainStoreInactiveVariantsWithStockListComponent extends ListComponentGeneric<IMainStoreInactiveVariant> implements OnInit {

  protected readonly exportedTableVisibleName = 'Inaktive Varianten mit Bestand';
  protected readonly defaultSorting = {
    sortField: 'inStock',
    sortOrder: 'descend'
  };

  constructor(
    protected _articlesService: ArticlesService<IMainStoreInactiveVariant>,
    protected _cdr: ChangeDetectorRef,
    protected _notify: NotificationService,
    protected renderer: Renderer2,
    protected _errorResolver: ArticlesServiceErrorResolverService
  ) {
    super(_articlesService, _cdr, _notify, renderer, _errorResolver);
  }

  public callService(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortOrder: string,
    filters: Array<{ key: string; value: string[]; operator?: FilterOperator }>,
    search: Array<{ key: string; value: string[]; operator?: FilterOperator }>,
    additionalFilters: Array<{ key: string; value: string[]; operator?: FilterOperator }>
  ): void {
    this.loading = true;
    this._articlesService.getMainStoreInactiveVariantsWithStock(
      pageIndex,
      pageSize,
      sortField,
      sortOrder,
      filters,
      search,
      additionalFilters
    ).subscribe(
      res => {
        this.loading = false;
        this.data = res;
        this.onListDataAvailable();
        this._cdr.detectChanges();
      },
      this.parseError
    );
  }
}
